// InviteLinkPage.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import defaultChannelImage2 from '../../images/channels/channel-1.png'
import styles from './channel.module.css';
import NavHeader from '../../shared/Nav-Header';


const InviteLinkPage = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [channelInfo, setChannelInfo] = useState(null);
    const [error, setError] = useState(null);
    const [joining, setJoining] = useState(false);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        fetchChannelInfo();
    }, [token]);

    const fetchChannelInfo = async () => {
        try {
            const response = await axios.get(`/api/channel/invite-info/${token}`);
            if (response.data.success) {
                setChannelInfo(response.data.channel);
                setShowModal(true);
                // console.log('Fetched channel info:', response.data.channel);
            }
        } catch (err) {
            // console.error('Error fetching channel info:', err.message);
            setError(err.response?.data?.message || 'Failed to load channel information');
        }
    };

    const handleJoinChannel = async () => {
        setJoining(true);
        try {
            const response = await axios.post(`/api/channel/join-via-invite`, 
                { token },
                { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
            );

            if (response.data.success) {
                navigate(`/channel/${response.data.channelId}`);
            }
        } catch (err) {
            const errorMsg = err.response?.data?.message || 'Failed to join channel';
            // console.error('Error joining channel:', errorMsg);
            // If token expired or invalid, close modal
            if (err.response?.status === 410 || err.response?.status === 404) {
                setShowModal(false);
            }
        } finally {
            setJoining(false);
        }
    };

    const handleCancel = () => {
        setShowModal(false);
        navigate('/channels');
    };

    const getTimeRemaining = () => {
        if (!channelInfo?.expiresAt) return '';
        const now = new Date();
        const expires = new Date(channelInfo.expiresAt);
        const diff = expires - now;
        
        if (diff < 0) return 'Expired';
        
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        
        if (days > 0) {
            return `Expires in ${days} day${days > 1 ? 's' : ''} ${hours}h`;
        }
        return `Expires in ${hours} hour${hours > 1 ? 's' : ''}`;
    };

    if (error) {
        return (
            <div  >
                <div  >
                    <h2 >Invalid Invite Link</h2>
                    <p >{error}</p>
                    <button onClick={() => navigate('/channels')}>
                        Browse Channels
                    </button>
                </div>
            </div>
        );
    }

    return (
        <>
        <NavHeader/>
            {showModal && channelInfo && (
                <div >
                    <img 
                        title={channelInfo.name} 
                        src={channelInfo.profilePicture ? channelInfo.profilePicture.replace('/upload/', '/upload/w_288,h_300,c_fill/') : defaultChannelImage2}alt="pfp" 
                        className={styles.networkProfilePicture} 
                    />                    <h1 >{channelInfo.name}</h1>
                    <span >{channelInfo.memberCount} members</span>
                    <p >{getTimeRemaining()}</p>

                    <h3 >About this Channel</h3>
                    <p>{channelInfo.description}</p>
                    <p> You've been invited to join this channel!</p>
                    <p>Click "Join Channel" to become a member and start participating.</p>
                    <button onClick={handleJoinChannel}  disabled={joining} >
                        {joining ? 'Joining...' : 'Join Channel'}
                    </button>
                    <button onClick={handleCancel} disabled={joining} >
                        Cancel
                    </button>
                </div>
            )}
        </>
    );
};

export default InviteLinkPage;